import React, { useEffect, useReducer } from 'react';
import { PARAMETERS_LIST } from '../../../../constants/EmailServicesConst';
import BackgroundColor from '../../../../shared/email-services/background-color/BackgroundColor';
import DividerLine from '../../../../shared/email-services/divider-line/DividerLine';
import PaddingComponent from '../../../../shared/email-services/padding-component/PaddingComponent';
import CustomMultiSelect from '../../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate, handleValidation } from '../../../../utils/formUtils';
import './ButtonComponent.scss';

const ButtonComponent = (props) => {
  const {
    onItemChange,
    componentObj,
    componentId,
    subId,
    activeNdx,
    isRemovable,
    onRemoveComponent,
  } = props;

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    buttonColor: {
      value: '',
      fieldName: 'Hex Code',
      errors: {},
      validations: [],
      tab: 0,
    },
    text: {
      value: '',
      fieldName: 'Add Button Text',
      errors: {},
      validations: [],
      tab: 0,
    },
    url: {
      value: '',
      fieldName: 'Add Button URL',
      errors: {},
      validations: ['validUrl'],
      tab: 0,
    },
    parameters: {
      value: [],
      fieldName: 'Button Parameters',
      errors: {},
      validations: [],
      tab: 0,
    },
    padding: {
      value: false,
      fieldName: 'Padding',
      errors: {},
      validations: [],
      tab: 0,
    },
    top: {
      value: '10',
      fieldName: 'Top',
      errors: {},
      validations: [],
      tab: 0,
    },
    bottom: {
      value: '10',
      fieldName: 'Bottom',
      errors: {},
      validations: [],
      tab: 0,
    },
    left: {
      value: '10',
      fieldName: 'Left',
      errors: {},
      validations: [],
      tab: 0,
    },
    right: {
      value: '10',
      fieldName: 'Right',
      errors: {},
      validations: [],
      tab: 0,
    },
    hexCode: {
      value: '#82828214',
      fieldName: 'Hex Code',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  const validate = () => {
    const isValid = formDataValidate(formData, false);
    return isValid;
  };

  useEffect(() => {
    const currFields = { ...formData };
    if (componentObj && Object.keys(componentObj).length > 0) {
      for (let field in currFields) {
        if (componentObj[field] !== undefined) currFields[field].value = componentObj[field];
      }
      if (!componentObj.parameters) {
        {
          currFields.parameters = {
            ...formData.parameters,
            value: [],
          };
        }
      } else {
        if (typeof componentObj.parameters === 'string') {
          if (componentObj.parameters === '[]' || componentObj.parameters === 'null') {
            currFields.parameters = {
              ...formData.parameters,
              value: [],
            };
          } else {
            const replace = ['[', ']'];
            let newParameters = componentObj.parameters;
            replace.forEach((val) => {
              newParameters = newParameters.replace(val, '');
            });
            const currParameters = newParameters.split(',').map((currValue) => {
              return currValue.trimStart();
            });
            currFields.parameters = {
              ...formData.parameters,
              value: currParameters,
            };
          }
        }
      }
    }
    setFormData(currFields);
  }, [activeNdx]);

  useEffect(() => {
    onItemChange({
      id: componentId,
      subId: subId || null,
      buttonColor: formData.buttonColor.value,
      text: formData.text.value,
      url: formData.url.value,
      parameters: formData.parameters.value?.length > 0 ? formData.parameters.value : null,
      padding: formData.padding.value,
      top: Number(formData.top.value),
      bottom: Number(formData.bottom.value),
      left: Number(formData.left.value),
      right: Number(formData.right.value),
      hexCode: formData.hexCode.value,
      index: componentObj?.index > -1 ? componentObj?.index : -1,
      isValid: validate(),
    });
  }, [formData]);

  useEffect(() => {
    handleValidation(formData?.url);
  }, []);

  return (
    <div className='button-component'>
      <div className='d-flex justify-content-between'>
        <p className='edit-button'>Edit Button</p>
        {isRemovable && (
          <p className='edit-button remove-text' onClick={() => onRemoveComponent()}>
            Remove
          </p>
        )}
      </div>
      <div className='mt-3'>
        <BackgroundColor
          formData={formData}
          setFormData={setFormData}
          title='Button Color'
          fieldKey='buttonColor'
        />
      </div>
      <div className='mt-3'>
        <CustomTextField
          item={formData.text}
          handleInputChange={(e) => {
            setFormData({ text: e });
          }}
          maxLength={1000}
        />
      </div>
      <div className='mt-3'>
        <CustomTextField
          item={formData.url}
          handleInputChange={(e) => {
            setFormData({ url: e });
          }}
          maxLength={1000}
        />
      </div>
      {Array.isArray(formData.parameters.value) && (
        <div className='mt-3'>
          <CustomMultiSelect
            item={formData.parameters}
            options={PARAMETERS_LIST}
            hideNullOption={true}
            handleInputChange={(e) => setFormData({ parameters: e })}
          />
        </div>
      )}
      <div className='mt-3'>
        <PaddingComponent formData={formData} setFormData={setFormData} />
      </div>
      <DividerLine />
      <div className='mt-5'>
        <BackgroundColor
          formData={formData}
          setFormData={setFormData}
          title='Background Color'
          fieldKey='hexCode'
        />
      </div>
    </div>
  );
};

export default ButtonComponent;
